<template>
  <div class="dados mt-5">
    <div class="row">
      <div class="col-12 mt-3">
        <h1 class="font-weight-bold text-uppercase tamanhoFonte" id="inicio">Pedidos de cadastrado</h1>
      </div>
    </div>

    <hr class="linha-amarela" />

    <div class="row mt-4">
      <div class="col-12">
        <i class="fas fa-users fa-2x c-orange mr-2"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Recomendações
        </h4>
      </div>
      
      <div class="col-12 mt-2">
        <table class="table">
          <thead class="letter-orange">
            <tr>
              <th scope="col">Responsável / Loja</th>
              <th scope="col">CNPJ</th>
              <th scope="col">WhatsApp</th>
              <th scope="col">Cidade - UF</th>
              <th scope="col">Gerente</th>
              <th scope="col">Status</th>
              <th scope="col">Data</th>
              <th style="width: 120px;">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in data" :key="i">
              <td>{{ item.nome_responsavel }} / {{ item.nome_fantasia }}</td>
              <td>{{ formatDoc('cnpj', item.cnpj) }}</td>
              <td>{{ formatDoc('cell', item.whatsapp) }}</td>
              <td>{{ item.cidade_uf }}</td>
              <td>{{ item.nome }} {{ item.sobrenome }}</td>
              <td>{{ item.status }}</td>
              <td>{{ formatDate(item.created_at) }}</td>
              <td>
                <span class="btn btn-primary mr-2" @click="verObs(item.observacao)">
                  <i class="fas fa-eye"></i>
                </span>
                <span class="btn btn-success" @click="editarStatus(item.status, item.id)">
                  <i class="fas fa-edit"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      title="Editar status"
      id="addLojista"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
        <div class="row">
          <div class="col-12">
            <label>Novo status</label>
            <input type="text" class="form-control" v-model="fields.status">
          </div>

          <div class="col-12 mt-4 text-center">
            <button class="btn btn-success" @click="salvarDados()">
              <i class="fas fa-save mr-2"></i>
              Salvar
            </button>
          </div>
        </div>
    </b-modal>

    <b-modal
      title="Ver Observação"
      id="verObs"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
        <div class="row">
          <div class="col-12">
            <span>
              {{observacao ? observacao : 'Sem Observação'}}
            </span>
          </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import makeToast from "../../mixins/makeToast";

export default {
  name: "PedidosRecomendacoes",
  mixins: [makeToast],

  data: () => ({
    observacao: '',
    fields: {
      status: '',
      id: null,
    },
    data: []
  }),

  computed: {
    ...mapState(['dadosUsuario'])
  },

  created() {
    this.buscarRecomendacoes();
  },

  methods: {
    formatDate(value){
      let dataObj = new Date(value);
      return dataObj.toLocaleString("pt-BR", { timeZone: "UTC", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" });
    },
    verObs(text) {
      this.observacao = text;
      this.$bvModal.show('verObs');
    },
    editarStatus(status, id) {
      this.fields.status = status;
      this.fields.id = id;

      this.$bvModal.show('addLojista');
    },
    salvarDados() {
      if(this.fields.status != '') {

        this.$store.dispatch('startLoader');
        this.$store.dispatch('gerente/atualizarRecomendacao', this.fields)
          .then((response) => {
            if(response.data.error == false) {
              this.makeToast('sucesso', response.data.message, 'success');
              this.$bvModal.hide('addLojista');

              this.buscarRecomendacoes();
            } else {
              this.makeToast('Oopss', response.data.message, 'danger');
            }            
          })
          .catch(() => {
            this.makeToast('Oopss', 'Erro ao atualizar!', 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      }
    },
    formatDoc(tipo, value) {
      if(tipo == 'cnpj') {
        return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1 $2 $3/$4-$5");
      } else if(tipo == 'cell') {
        if (!value) return ""

        var value = value.replace(/\D/g, "");
        value = value.replace(/^0/, "");

        if (value.length > 10) {
          value = value.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
        } else if (value.length > 5) {
          value = value.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
        } else if (value.length > 2) {
          value = value.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
        } else {
          value = value.replace(/^(\d*)/, "($1");
        }
        return value;
      }
    },
    buscarRecomendacoes() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('gerente/listarRecomendacoesAll')
        .then((response) => {
          if(response.data){
            this.data = response.data;
          }         
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao buscar lojistas!', 'danger')
        })
        .finally(() => {
          this.$store.dispatch('endLoader')
        });
    }
  },
};
</script>

<style scoped>
@media only screen and (max-width: 500px) {
  .tamanhoFonte{
    font-size: 20px;
  }
}
</style>